import './App.css';

function App() {
  return (
    <div className="App">
      <header className="main-header">
        <h1>Motoyoe LLC</h1>
        <p>Logistics and distribution solutions for Amazon Wholesale sellers</p>
      </header>

      <main className="main-content">
        <section>
          <h2>About Us</h2>
          <p>
            Motoyoe LLC is a company focused on providing logistics and distribution solutions for Amazon sellers in the wholesale model. Our mission is to connect trusted brands with committed customers, ensuring compliance, transparency, and efficiency in every order.
          </p>
        </section>

        <section>
          <h2>What We Do</h2>
          <ul>
            <li>We work with wholesalers and manufacturers in the United States.</li>
            <li>We validate products for Amazon FBA compliance.</li>
            <li>We manage inventory, order processing, and logistics coordination.</li>
          </ul>
        </section>

        <section>
          <h2>Services</h2>
          <ul>
            <li>Product research and evaluation for wholesale.</li>
            <li>Supplier account setup and relationship management.</li>
            <li>Amazon viability analysis (price, demand, fees).</li>
            <li>Preparation and shipment to FBA fulfillment centers.</li>
            <li>Post-sale support and tracking.</li>
          </ul>
        </section>

        <section>
          <h2>Contact</h2>
          <p>Email: <a href="mailto:purchasing@motoyoe.com">purchasing@motoyoe.com</a></p>
          <p>Location: Miami, FL (USA)</p>
        </section>
      </main>

      <footer className="main-footer">
        © 2025 Motoyoe LLC – All rights reserved.
      </footer>
    </div>
  );
}

export default App;
